import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ConsultaDocumentosLiquidados = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  // Estados principales
  const [respuestaApi, setRespuestaApi] = useState([]);
  const [respuestaApiOriginal, setRespuestaApiOriginal] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [fechaConsulta, setFechaConsulta] = useState(getCurrentDate()); //'2025-04-10');

  
  // Estados para filtros
  const [filtroRuta, setFiltroRuta] = useState('');
  const [filtroDocumento, setFiltroDocumento] = useState('');
  const [filtroCliente, setFiltroCliente] = useState('');
  const [filtroCondicionPago, setFiltroCondicionPago] = useState('');

  // Estados para selección e impresión
  const [documentosSeleccionados, setDocumentosSeleccionados] = useState([]);
  const [seleccionPorCondicion, setSeleccionPorCondicion] = useState('TODOS');
  const [resumenCondiciones, setResumenCondiciones] = useState([]);

  const datosParaEnviar = {
    Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
    Ambiente: 'DESA',
    Dispositivo: {
      Marca: 'SAMSUNG',
      Modelo: 'S22002B',
      Version: 'Android 18.125',
      McAdress: null,
      PowerStatus: '84%',
      WifiStatus: 'Conected to iphone de Mauricio',
      GPSStatus: 'ON',
      GPS: '321|-485|321'
    },
    Usr: {
      Codigo: '',
      UserNickName: 'pierril'
    },
    DatosMetodo: {
      NombreMetodo: 'ObtenerListaLiquidacionesWeb',
      Datos_Recibidos: '',
      datos_Generados: ''
    }
  };

  // Calcular resumen por condición de pago
  const calcularResumen = (datos) => {
    const resumen = {};
    
    datos.forEach(item => {
      const condicion = item.Condicion_Pago || 'SIN CONDICIÓN';
      const total = parseFloat(item.Total_Documento) || 0;
      
      if (!resumen[condicion]) {
        resumen[condicion] = {
          condicion: condicion,
          total: 0,
          cantidad: 0
        };
      }
      
      resumen[condicion].total += total;
      resumen[condicion].cantidad += 1;
    });
    
    return Object.values(resumen);
  };

  // Función para aplicar los filtros
  const aplicarFiltros = () => {
    let datosFiltrados = [...respuestaApiOriginal];
    
    if (filtroRuta) {
      datosFiltrados = datosFiltrados.filter(item => 
        item.Ruta?.toString().toLowerCase().includes(filtroRuta.toLowerCase())
      );
    }
    
    if (filtroDocumento) {
      datosFiltrados = datosFiltrados.filter(item => 
        item.Num_Documento?.toString().toLowerCase().includes(filtroDocumento.toLowerCase())
      );
    }
    
    if (filtroCliente) {
      datosFiltrados = datosFiltrados.filter(item => 
        item.Nombre_CLiente?.toLowerCase().includes(filtroCliente.toLowerCase()) ||
        item.Codigo_Cliente?.toString().toLowerCase().includes(filtroCliente.toLowerCase())
      );
    }
    
    if (filtroCondicionPago) {
      datosFiltrados = datosFiltrados.filter(item => 
        item.Condicion_Pago?.toLowerCase().includes(filtroCondicionPago.toLowerCase())
      );
    }
    
    setRespuestaApi(datosFiltrados);
    setResumenCondiciones(calcularResumen(datosFiltrados));
  };

  // Función para limpiar los filtros
  const limpiarFiltros = () => {
    setFiltroRuta('');
    setFiltroDocumento('');
    setFiltroCliente('');
    setFiltroCondicionPago('');
    setRespuestaApi(respuestaApiOriginal);
    setResumenCondiciones(calcularResumen(respuestaApiOriginal));
  };

  const consultarApi = async () => {
    setCargando(true);
    setError(null);
    
    try {
      const requestData = {
        ...datosParaEnviar,
        DatosMetodo: {
          ...datosParaEnviar.DatosMetodo,
          Datos_Recibidos: JSON.stringify({ Fecha: fechaConsulta })
        }
      };
  
      const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(requestData))}`;
      const respuesta = await fetch(url);
      
      if (!respuesta.ok) {
        throw new Error(`Error HTTP: ${respuesta.status}`);
      }
  
      const datos = await respuesta.json();
      
      if (!datos.datos_Generados) {
        throw new Error('No se encontraron datos generados en la respuesta');
      }
      
      const datosGenerados = JSON.parse(datos.datos_Generados);
      const liquidaciones = datosGenerados.LIQUIDACION || [];
      const liquidacionesFiltradas = liquidaciones.filter(item => item.sp_estado === 15);
      
      setRespuestaApi(liquidacionesFiltradas);
      setRespuestaApiOriginal(liquidacionesFiltradas);
      setResumenCondiciones(calcularResumen(liquidacionesFiltradas));
      setDocumentosSeleccionados(liquidacionesFiltradas.map(item => item.Num_Documento));
    } catch (err) {
      setError(err.message);
      console.error('Error al consultar la API:', err);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    consultarApi();
  }, []);

  useEffect(() => {
    aplicarFiltros();
  }, [filtroRuta, filtroDocumento, filtroCliente, filtroCondicionPago]);

  const formatearFecha = (fechaISO) => {
    if (!fechaISO) return '';
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-GT');
  };

  const handleFechaChange = (e) => {
    setFechaConsulta(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    consultarApi();
  };

  // Manejar selección de documentos individuales
  const toggleSeleccionDocumento = (documento) => {
    setDocumentosSeleccionados(prev => {
      if (prev.includes(documento)) {
        return prev.filter(doc => doc !== documento);
      } else {
        return [...prev, documento];
      }
    });
  };

  // Manejar selección por condición de pago
  const handleSeleccionCondicion = (condicion) => {
    setSeleccionPorCondicion(condicion);
    
    if (condicion === 'TODOS') {
      setDocumentosSeleccionados(respuestaApi.map(item => item.Num_Documento));
    } else {
      const docsCondicion = respuestaApi
        .filter(item => item.Condicion_Pago === condicion)
        .map(item => item.Num_Documento);
      setDocumentosSeleccionados(docsCondicion);
    }
  };

  // Función para manejar la impresión
  const handlePrint = () => {
    const documentosAImprimir = respuestaApi.filter(item => 
      documentosSeleccionados.includes(item.Num_Documento)
    );
    
    if (documentosAImprimir.length === 0) {
      alert('No hay documentos seleccionados para imprimir');
      return;
    }

    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>Documentos Liquidados - ${fechaConsulta}</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            @media print {
              body { padding: 20px; font-family: Arial, sans-serif; }
              h2 { margin-bottom: 20px; text-align: center; }
              table { width: 100%; border-collapse: collapse; margin-top: 15px; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; font-weight: bold; }
              .text-end { text-align: right; }
              .badge { padding: 3px 6px; border-radius: 3px; font-size: 12px; }
              .bg-success { background-color: #28a745; color: white; }
              .bg-danger { background-color: #dc3545; color: white; }
              .resumen { margin-bottom: 20px; border: 1px solid #ddd; padding: 10px; }
              .resumen h4 { margin-top: 0; }
            }
            @page { size: auto; margin: 10mm; }
          </style>
        </head>
        <body>
          <h2>Documentos Liquidados - ${formatearFecha(fechaConsulta)}</h2>
          
          <div class="resumen">
            <h4>Resumen por Condición de Pago</h4>
            <table class="table">
              <thead>
                <tr>
                  <th>Condición de Pago</th>
                  <th>Cantidad Documentos</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                ${resumenCondiciones.map(item => `
                  <tr>
                    <td>${item.condicion}</td>
                    <td>${item.cantidad}</td>
                    <td>Q ${item.total.toFixed(2)}</td>
                  </tr>
                `).join('')}
                <tr style="font-weight: bold;">
                  <td>TOTAL GENERAL</td>
                  <td>${resumenCondiciones.reduce((sum, item) => sum + item.cantidad, 0)}</td>
                  <td>Q ${resumenCondiciones.reduce((sum, item) => sum + item.total, 0).toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <h4>Documentos Seleccionados (${documentosAImprimir.length})</h4>
          <table class="table">
            <thead>
              <tr>
                <th>Ruta</th>
                <th>No. Ref.</th>
                <th>Documento</th> 
                <th>Codigo Cliente</th> 
                <th>Nombre de Cliente</th>
                <th>Fecha Doc.</th>
                <th>Total</th>
                <th>Liquidacion de documento</th>
                <th>Condición Pago</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              ${documentosAImprimir.map((item, index) => `
                <tr key="${index}">
                  <td>${item.Ruta || ''}</td>
                  <td>${item.Num_Ref || ''}</td> 
                  <td>${item.Num_Documento || ''}</td>
                  <td>${item.Codigo_Cliente || ''}</td>
                  <td>${item.Nombre_CLiente || ''}</td>
                  <td>${formatearFecha(item.Fecha_Doc)}</td>
                  <td class="text-end">Q ${item.Total_Documento?.toFixed(2) || '0.00'}</td> 
                  <td>${item['Liquidacion Documento'] || ''}</td>
                  <td>${item.Condicion_Pago || ''}</td>
                  <td>
                    <span class="badge ${item.Pagado === 'No Pagada' ? 'bg-danger' : 'bg-success'}">
                      ${item.Pagado || ''}
                    </span>
                  </td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          <script>
            setTimeout(() => {
              window.print();
              window.close();
            }, 200);
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div className="container mt-4">
      <div className="card border-0 shadow-none">
        <div className="card-header bg-transparent border-0 px-0 pt-0">
          <h1 className="text-center mb-4">Consulta de Documentos Liquidados</h1>
        </div>
        
        <div className="card-body px-0">
          <form onSubmit={handleSubmit} className="mb-4">
            <div className="row g-3 align-items-center">
              <div className="col-md-4">
                <label htmlFor="fechaConsulta" className="form-label">Fecha de Factura:</label>
                <input 
                  type="date" 
                  id="fechaConsulta" 
                  className="form-control"
                  value={fechaConsulta}
                  onChange={handleFechaChange}
                />
              </div>
              <div className="col-md-4 d-flex align-items-end">
                <button 
                  type="submit" 
                  disabled={cargando}
                  className="btn btn-success"
                >
                  {cargando ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Consultando...
                    </>
                  ) : 'Consultar'}
                </button>
              </div>
            </div>
          </form>
          
          {/* Sección de Filtros */}
          <div className="card mb-4">
            <div className="card-header bg-light">
              <h5 className="mb-0">Filtros</h5>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-3">
                  <label htmlFor="filtroRuta" className="form-label">Ruta</label>
                  <input
                    type="text"
                    id="filtroRuta"
                    className="form-control"
                    placeholder="Filtrar por ruta"
                    value={filtroRuta}
                    onChange={(e) => setFiltroRuta(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="filtroDocumento" className="form-label">Documento</label>
                  <input
                    type="text"
                    id="filtroDocumento"
                    className="form-control"
                    placeholder="Filtrar por documento"
                    value={filtroDocumento}
                    onChange={(e) => setFiltroDocumento(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="filtroCliente" className="form-label">Cliente</label>
                  <input
                    type="text"
                    id="filtroCliente"
                    className="form-control"
                    placeholder="Filtrar por cliente"
                    value={filtroCliente}
                    onChange={(e) => setFiltroCliente(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="filtroCondicionPago" className="form-label">Condición de Pago</label>
                  <input
                    type="text"
                    id="filtroCondicionPago"
                    className="form-control"
                    placeholder="Filtrar por condición"
                    value={filtroCondicionPago}
                    onChange={(e) => setFiltroCondicionPago(e.target.value)}
                  />
                </div>
                <div className="col-12 text-end">
                  <button 
                    type="button" 
                    className="btn btn-outline-secondary"
                    onClick={limpiarFiltros}
                  >
                    Limpiar Filtros
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          {error && (
            <div className="alert alert-danger d-flex justify-content-between align-items-center">
              <span>Error: {error}</span>
              <button onClick={consultarApi} className="btn btn-sm btn-danger">
                Reintentar
              </button>
            </div>
          )}
          
          {/* Resumen por condición de pago */}
          {resumenCondiciones.length > 0 && (
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0">Resumen por Condición de Pago</h5>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Condición de Pago</th>
                        <th>Cantidad Documentos</th>
                        <th>Total</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resumenCondiciones.map((item, index) => (
                        <tr key={index}>
                          <td>{item.condicion}</td>
                          <td>{item.cantidad}</td>
                          <td>Q {item.total.toFixed(2)}</td>
                          <td>
                            <button 
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => handleSeleccionCondicion(item.condicion)}
                            >
                              Seleccionar
                            </button>
                          </td>
                        </tr>
                      ))}
                      <tr className="table-active">
                        <td><strong>TOTAL GENERAL</strong></td>
                        <td><strong>{resumenCondiciones.reduce((sum, item) => sum + item.cantidad, 0)}</strong></td>
                        <td><strong>Q {resumenCondiciones.reduce((sum, item) => sum + item.total, 0).toFixed(2)}</strong></td>
                        <td>
                          <button 
                            className="btn btn-sm btn-primary"
                            onClick={() => handleSeleccionCondicion('TODOS')}
                          >
                            Seleccionar Todos
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
          
          <div className="table-responsive">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2>Resultados de Documentos Liquidados</h2>
              {respuestaApi.length > 0 && (
                <div>
                  <span className="me-3">
                    Documentos seleccionados: {documentosSeleccionados.length} de {respuestaApi.length}
                  </span>
                  <button 
                    onClick={handlePrint}
                    className="btn btn-primary"
                    disabled={documentosSeleccionados.length === 0}
                  >
                    <i className="bi bi-printer-fill me-2"></i> Imprimir Selección
                  </button>
                </div>
              )}
            </div>
            {cargando ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </div>
                <p className="mt-2">Cargando datos...</p>
              </div>
            ) : respuestaApi.length > 0 ? (
              <table className="table table-striped table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Selección</th>
                    <th>Ruta</th>
                    <th>No. Ref.</th>
                    <th>Documento</th> 
                    <th>Codigo Cliente</th> 
                    <th>Nombre de Cliente</th>
                    <th>Fecha Doc.</th>
                    <th>Total</th>
                    <th>Liquidacion de documento</th>
                    <th>Condición Pago</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {respuestaApi.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="checkbox"
                          checked={documentosSeleccionados.includes(item.Num_Documento)}
                          onChange={() => toggleSeleccionDocumento(item.Num_Documento)}
                        />
                      </td>
                      <td>{item.Ruta}</td>
                      <td>{item.Num_Ref}</td> 
                      <td>{item.Num_Documento}</td>
                      <td>{item.Codigo_Cliente}</td>
                      <td>{item.Nombre_CLiente}</td>
                      <td>{formatearFecha(item.Fecha_Doc)}</td>
                      <td className="text-end">Q {item.Total_Documento?.toFixed(2)}</td> 
                      <td>{item['Liquidacion Documento']}</td>
                      <td>{item.Condicion_Pago}</td>
                      <td>
                        <span className={`badge ${item.Pagado === 'No Pagada' ? 'bg-danger' : 'bg-success'}`}>
                          {item.Pagado}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="alert alert-info">
                No se encontraron documentos liquidados para la fecha seleccionada.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultaDocumentosLiquidados;